import styled from "styled-components";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import { useState, useEffect } from "react";
import React from "react";
import request from "../../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";

const FadeBackground = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10000;
    left: 0;
    top: 0;
    background-color: #32323233;
`;

const StyledYearEndSignOff = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    box-sizing: border-box;
    width: 400px;
    height: 310px;
    border-radius: 5px;
    margin: auto;
    padding: 30px;
    font-size: 12px;
    font-weight: 600;
    z-index: 9999;
`;

const ModalTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

function YearEndSignOff(props) {

    const [fromYear, setFromYyear] = useState('All years');
    const [regionName, setRegionName] = useState('All Regions')
    const [isDownloading, setIsDownloading] = useState(false);

    const [loadedPage, setLoadedPage] = useState(false);
    const [regionList, setRegionList] = useState([]);
    const [regionNameList, setRegionNameList] = useState([]);

    let currentYear = new Date().getFullYear();
    let years = [];
    for (let i = currentYear - 20; i < currentYear + 5; i ++) {
        years.push(i);
    }

    const handleClickFadeBackground = (e) => {
        if (props.handleClickNo) {
            props.handleClickNo();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    const onClickDownload = async () => {
        setIsDownloading(true);

        let details = {};
        
        details.FromYear = fromYear === 'All years' ? 0 : parseInt(fromYear);
        details.RegionCode = regionNameToRegionCode(regionName);
        const resp = (await request('database', 'downloadYearEndSignOff', [details]));
        if (resp.ok) {
            let fileName = `Year End Sign Off Report.xlsx`;
            var fileDownload = require('js-file-download');
            fileDownload(resp.data, fileName);
        } else {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDownloading(false);
    }
    
    const fetchRegions = async () => {
        try {
            let regions = [];
            let regionNames = [];

            const resp = (await request('database', 'fetchRegions'));
            if (resp.ok) {
                resp.data.map((item, index) => {
                    regions.push(item);
                    regionNames.push(item.RegionName);
                });
                setRegionList(regions);
                setRegionNameList(regionNames);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch regions: ', e);
            return false;
        }
        return true;
    }

    const regionNameToRegionCode = (rName) => {
        let ret = null;
        if (rName === 'All Regions') {
            return null;
        }

        regionList.map((r) => {
            if (r.RegionName === rName) {
                ret = r.RegionCode;
            }
        });

        return ret;
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchRegions();
            setLoadedPage();
        }
    }, []);

    return (
        <FadeBackground onClick={handleClickFadeBackground}>
            <StyledYearEndSignOff onClick={(e) => {e.stopPropagation(); e.preventDefault()}} {...props}>
                <ModalTitle>Year end sign off report</ModalTitle>
                <FormSelectWithLabel label='From accounting year' items={['All years', ...years]} value={fromYear} onChange={(e) => setFromYyear(e.target.value)} style={{width:340, height:35, paddingLeft:10}}></FormSelectWithLabel>
                <FormSelectWithLabel label='Region' items={['All Regions', ...regionNameList]} value={regionName} onChange={(e) => setRegionName(e.target.value)} style={{width:340, height:35, paddingLeft:10}}></FormSelectWithLabel>
                <div style={{display:'flex', marginTop:30}}>
                    <SecondaryButton caption='Cancel' onClick={() => props.handleClickNo ? props.handleClickNo() : {}} style={{width:126, height:35}}></SecondaryButton>
                    <PrimaryButton caption='Download to Excel' isLoading={isDownloading} onClick={() => onClickDownload()} style={{width:150, height:35, marginLeft:'auto'}}></PrimaryButton>
                </div>
            </StyledYearEndSignOff>
        </FadeBackground>
    );
}

export default YearEndSignOff;